/// <amd-module name="SuiteCommerce.LookBook.LookBook.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.LookBook.LookBook.Model", ["require", "exports", "Backbone", "SuiteCommerce.LookBook.Common.Utils", "SuiteCommerce.LookBook.Look.Collection"], function (require, exports, Backbone_1, Utils_1, Look_Collection_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LookBookModel = void 0;
    var LookBookModel = /** @class */ (function (_super) {
        __extends(LookBookModel, _super);
        function LookBookModel() {
            var _this = _super.call(this) || this;
            _this.urlRoot = Utils_1.Utils.getAbsoluteUrl(getExtensionAssetsPath('services/LookBook.Service.ss'));
            _this.setupListeners();
            return _this;
        }
        LookBookModel.prototype.setupListeners = function () {
            this.on('change:looks', function (model, looks) {
                model.set('looks', new Look_Collection_1.LookCollection(looks), { silent: true });
            });
        };
        LookBookModel.prototype.getName = function () {
            return this.get('name');
        };
        LookBookModel.prototype.getMetaDescription = function () {
            return this.get('metadesc') || this.get('longdesc');
        };
        LookBookModel.prototype.getMetaKeywords = function () {
            return this.get('metakeys') || this.get('name');
        };
        LookBookModel.prototype.getTitle = function () {
            return this.get('title') || this.get('name');
        };
        LookBookModel.prototype.getUrlComponent = function () {
            return this.get('urlcomponent');
        };
        LookBookModel.prototype.getShortDesc = function () {
            return this.get('shortdesc');
        };
        LookBookModel.prototype.getLongDesc = function () {
            return this.get('longdesc');
        };
        LookBookModel.prototype.getAlign = function () {
            return this.get('align');
        };
        LookBookModel.prototype.getTextColor = function () {
            return this.get('textcolor');
        };
        LookBookModel.prototype.getImage = function () {
            return this.get('image');
        };
        LookBookModel.prototype.getLooks = function () {
            return this.get('looks');
        };
        return LookBookModel;
    }(Backbone_1.Model));
    exports.LookBookModel = LookBookModel;
});
